import { Injectable } from "@angular/core"
import { BybitWebsocketClient } from "../../../market"
import { Observable } from "rxjs"
import { Order, OrderSide, OrderType, PositionSide } from "../../../model/trade"
import { isWsAccountOrderEventV5 } from "libs/bybit-api/src"
import { parseFloatSafe, parseIntSafe } from "src/app/core/func"

@Injectable({
  providedIn: 'root'
})
export class BybitOrderHandler {

  listen(ws: BybitWebsocketClient) {
    return new Observable<Order>(subscriber => {
      const f = (data: any) => {
        // Проверяем, что это сообщение сделки и только category == 'linear'
        if (isWsAccountOrderEventV5(data)) {
          data.data.filter(row => row.category == 'linear').forEach(row => {
            const order: Order = {
              createdTimestamp: parseIntSafe(row.createdTime),
              updateTimestamp: parseIntSafe(row.updatedTime),
              type: row.orderType == 'Limit' ? OrderType.limit : (row.orderType == 'Market' ? OrderType.market : OrderType.unknown),
              status: row.orderStatus,
              market: 'bybit',
              board: 'linear',
              symbol: row.symbol,
              price: row.price,
              quantity: row.qty,
              volume: parseFloatSafe(row.price) * parseFloatSafe(row.qty),
              remainingQuantity: row.leavesQty ?? 0,
              remainingVolume: row.leavesValue ?? 0,
              side: row.side == 'Buy' ? OrderSide.buy : OrderSide.sell,
              positionSide: row.positionIdx == 1 ? PositionSide.long : row.positionIdx == 2 ? PositionSide.short : PositionSide.both,
              orderId: row.orderId,
              clientOrderId: row.orderLinkId,
              isStop: row.stopOrderType.includes('Stop'),
              isClosePosition: row.reduceOnly,
            }
            if (order.isStop) {
              order.price = row.triggerPrice
              order.volume = parseFloatSafe(order.price) * parseFloatSafe(order.quantity)
              order.remainingQuantity = order.quantity
              order.remainingVolume = order.volume
            }
            subscriber.next(order)
          })
        }
      }

      ws.on('update', f)
      return () => ws.off('update', f)
    })
  }

}
